// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b6f43377","513":"9506747e","703":"e4412fea","787":"7cd60242"}[chunkId] + ".chunk.js";
};